<template>
    <div class="kindergarten-main-banner">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-6 col-md-12">
                    <div class="kindergarten-banner-content" v-for="title of titles" :key="title.title_id">
                        <div class="image">
                            <img src="../../assets/img/shape/bird1.png" alt="image">
                        </div>
                        <h1>{{ title.title_header }}</h1>
                        <p>{{ title.title_content }}</p>
                        <router-link to="/iletisim" class="default-btn-style-two">
                            <i class="flaticon-user"></i>
                            {{ title.title_button }}
                        </router-link>
                        <div class="circle-shape">
                            <img src="../../assets/img/shape/circle.png" alt="image">
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-12">
                    <div class="kindergarten-banner-image">
                        <div class="row">

                            <div class="col-lg-6 col-md-6 col-sm-6" v-for="image of images" :key="image.image_id">
                                <div class="image">
                                    <img :src="getImgUrl('resimler', image.image_image)" alt="image">
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-6 col-sm-6">
                                <div class="image text-start">
                                    <img src="../../assets/img/kindergarten/kids4.png" class="mt-4" alt="image">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="kindergarten-shape1">
            <img src="../../assets/img/kindergarten-shape/k-shape1.png" alt="image">
        </div>
        <div class="kindergarten-shape2">
            <img src="../../assets/img/kindergarten-shape/k-shape2.png" alt="image">
        </div>
        <div class="kindergarten-shape3">
            <img src="../../assets/img/kindergarten-shape/k-shape3.png" alt="image">
        </div>
        <div class="kindergarten-shape4">
            <img src="../../assets/img/kindergarten-shape/k-shape4.png" alt="image">
        </div>
        <div class="kindergarten-shape5">
            <img src="../../assets/img/kindergarten-shape/k-shape5.png" alt="image">
        </div>
        <div class="kindergarten-shape6">
            <img src="../../assets/img/kindergarten-shape/k-shape6.png" alt="image">
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: 'MainBanner',
    props: ['pathUrl'],
    
    created() {
      this.getTitles();
      this.getImages();
    },
    data() {
      return {
        titles: [],
        images: [],
        errors: []
      };
    },
    methods: {
        getTitles() {
            axios.get(this.pathUrl + "?data=title&parent=2")
                .then(response => (this.titles = response.data.result))
                    .catch(error => {
                        this.errors.push(error);
                    });
        },
        getImages() {
            axios.get(this.pathUrl + "?data=image&parent=2")
                .then(response => (this.images = response.data.result))
                    .catch(error => {
                        this.errors.push(error);
                    });
        },
        getImgUrl(category, pet) {
            return require('../../../../assets/resimler/'+ category +'/'+ pet)
        }
    }
    
}








</script>